export function readCacheWithTtl(key, storage = sessionStorage) {
  try {
    const raw = storage.getItem(key)
    if (!raw) return null

    const { value, expiresAt } = JSON.parse(raw) || {}
    if (!expiresAt || Date.now() > expiresAt) {
      storage.removeItem(key)
      return null
    }

    return value
  } catch (e) {
    storage.removeItem(key)
    return null
  }
}

export function writeCacheWithTtl(key, value, ttlMs, storage = sessionStorage) {
  const payload = { value, expiresAt: Date.now() + ttlMs }
  storage.setItem(key, JSON.stringify(payload))
}

export function clearCache(key, storage = sessionStorage) {
  storage.removeItem(key)
}
